import { SET_RESOLUTION } from './';

export default resolution => ({ type: SET_RESOLUTION, payload: resolution });
